import { z } from "zod";
import { DbCreateInputOmit, DbUpdate } from "../../helpers";
import { OmitStrict } from "../../utils";

export const ElementPropertyTypeSchema = z.enum(["Text", "Number", "Boolean", "Select", "Generic", "Link", "URL"]);
export const ElementPropertyTargetType = z.enum(["Token", "Component", "DocumentationPage"]);
export const ElementPropertyLinkType = z.enum(["FigmaComponent", "DocumentationPage"]);
export const ElementPropertyImmutableType = z.enum(["Collection"]);

const CODE_NAME_REGEX = /^[a-zA-Z_$][a-zA-Z_$0-9]{1,99}$/;

export const ColorTokenInlineData = z.object({
  value: z.string(),
});

export const ElementPropertyDefinitionOption = z.object({
  id: z.string(),
  name: z.string(),
  backgroundColor: ColorTokenInlineData.optional(),
});

export const ElementPropertyDefinition = z.object({
  id: z.string(),
  designSystemVersionId: z.string(),
  persistentId: z.string(),
  name: z.string(),
  codeName: z.string().regex(CODE_NAME_REGEX),
  description: z.string(),
  type: ElementPropertyTypeSchema,
  targetElementType: ElementPropertyTargetType,
  options: z.array(ElementPropertyDefinitionOption).optional(),
  linkElementType: ElementPropertyLinkType.optional(),
});

export type ElementPropertyType = z.infer<typeof ElementPropertyTypeSchema>;
export const ElementPropertyType = ElementPropertyTypeSchema.enum;

export type ElementPropertyTargetType = z.infer<typeof ElementPropertyTargetType>;
export type ElementPropertyLinkType = z.infer<typeof ElementPropertyLinkType>;
export type ElementPropertyImmutableType = z.infer<typeof ElementPropertyImmutableType>;
export type ColorTokenInlineData = z.infer<typeof ColorTokenInlineData>;
export type ElementPropertyDefinitionOption = z.infer<typeof ElementPropertyDefinitionOption>;
export type ElementPropertyDefinition = z.infer<typeof ElementPropertyDefinition>;

export type CreateElementPropertyDefinition = DbCreateInputOmit<ElementPropertyDefinition> & {
  columnWidth?: number;
};

export type UpdateElementPropertyDefinition = OmitStrict<
  DbUpdate<ElementPropertyDefinition>,
  "designSystemVersionId" | "targetElementType" | "type" | "linkElementType"
>;

export type ElementPropertyDefinitionDiff = {
  toCreate: CreateElementPropertyDefinition[];
  toUpdate: UpdateElementPropertyDefinition[];
};
